import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Sidebar from '../components/Sidebar';
import ImageCarousel from '../components/ImageCarousel';
import MessagesSection from '../components/MessagesSection';
import NoticesPanel from '../components/NoticesPanel';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navigation />
      
      <div className="w-full py-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0">
          {/* Left Sidebar - Aligned to extreme left */}
          <div className="lg:col-span-2">
            <Sidebar />
          </div>
          
          {/* Main Content - Expanded width */}
          <div className="lg:col-span-8 px-4">
            <ImageCarousel />
            <MessagesSection />
          </div>
          
          {/* Right Sidebar - Aligned to extreme right */}
          <div className="lg:col-span-2">
            <NoticesPanel />
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Home;